import Search from '@components/Search';
import './Header.less';
import { useAppDispatch, useAppSelector } from '@hooks/useStore';
import { IconBurger } from '@images/svg/burger';
import { IconMenuClose } from '@images/svg/icon-menu-close';
import { IconMenuOpen } from '@images/svg/icon-menu-open';
import { IconLogo } from '@images/svg/logo';
import { useGetNamespaceQuery } from '@redux/api/adminApi';
import { setMenuOpen, setRightMenuOpen } from '@redux/slices/global';
import { IconShevronRight16 } from '@sberlab/core-icons';
import { IRootSlice } from '@typings/rootSlice';
import cn from 'classnames';
import React, { useEffect } from 'react';
import { useParams } from 'react-router';
import { Link } from 'react-router-dom';

interface HeaderProps {
    hideSearch?: boolean;
    hideMenu?: boolean;
}

const Header: React.FC<HeaderProps> = ({
    hideSearch,
    hideMenu,
}) => {
    const { namespace } = useParams();
    const dispatch = useAppDispatch();
    const menuOpen = useAppSelector((state: IRootSlice) => state.globalSlice.menuOpen);
    const rightMenuOpen = useAppSelector((state: IRootSlice) => state.globalSlice.rightMenuOpen);
    const menuToggleButtonClassName = cn('header__menu-toggle-button', {
        open: menuOpen,
    });
    const { data: namespaceData } = useGetNamespaceQuery(namespace, {
        skip: !namespace,
    });
    const documentTitle = namespaceData?.title || 'Справка';

    const checkView = () => {
        if (window.matchMedia('(max-width: 1200px)').matches) {
            dispatch(setMenuOpen(false));
        } else {
            dispatch(setMenuOpen(true));
        }
    };

    useEffect(() => {
        if (hideMenu) {
            setMenuOpen(false);
        } else {
            checkView();
        }

        let timer = null;
        const handleResize = () => {
            clearTimeout(timer);
            timer = setTimeout(() => checkView(), 300);
        };

        window.addEventListener('resize', handleResize);

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    const onToggle = () => {
        dispatch(setMenuOpen(!menuOpen));
    };

    const onToggleBurger = () => {
        dispatch(setRightMenuOpen(!rightMenuOpen));
    };

    return (
        <div className="header">
            <span className={menuToggleButtonClassName} onClick={onToggle}>
                {menuOpen ? <IconMenuOpen /> : <IconMenuClose />}
                <span className="header__menu-toggle-button__icon-chevron">
                    <IconShevronRight16 color='#fff' />
                </span>
            </span>
            <div className="header__main">
                <a href="https://ads.sber.ru" className="header__logo">
                    <IconLogo />
                </a>
                <div className="header__block">
                    <div className="header__block__menu">
                        <Link to='/help' className={`header__block__item ${documentTitle === 'Правовые документы' ? '' : 'active'}`}>Справка</Link>
                        <Link to='/legal' className={`header__block__item ${documentTitle === 'Правовые документы' ? 'active' : ''}`}>Правовые документы</Link>
                    </div>
                    {hideSearch ? null : <div className='header__block__input'><Search className="search__header" /></div>}
                    <a
                        className='header__block__button'
                        href="https://ads.sber.ru/td"
                    >
                        Войти
                    </a>
                </div>
                <div className='header__burger' onClick={onToggleBurger}><IconBurger /></div>
            </div>
        </div>
    );
};

export default Header;
